// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/dist/bootstrap-vue.css
// module id = 502
// module chunks = 1